import { ICalendarEvent, IChartData, ICompactChartData, IPaymentTransaction, IServiceProviderActivity, ITask } from '@/interfaces/dashboard.interface';
import { api } from '@/lib/api/axios';

interface ProponenteDashboard {
  hero: {
    userName: string,
    newOrders: number,
    pendingItems: number,
    newMessages: number,
    hasPendingPayment: boolean,
  },
  stats: {
    contractsExpiring: number,
    contractsPercentage: number,
    budgetSpent: string,
    budgetPercentage: number,
    tasksInProgress: number,
    tasksPercentage: number,
    activeUsers: number,
    usersPercentage: number,
  },
  payments: IPaymentTransaction[],
  contractsChart: IChartData[],
  teamChart: IChartData[],
  salesChart: IChartData[],
  financeChart: IChartData[],
  profile: {
    name: string,
    role: string,
    function: string,
    company: string,
    bio: string,
    socialLinks: {
      linkedin?: string,
      twitter?: string,
      facebook?: string,
      instagram?: string,
    },
    avatar: string,
  },
  activities: IServiceProviderActivity[],
  tasks: ITask[],
  calendarEvents: ICalendarEvent[],
  invoicesChart: ICompactChartData,
  contractsOverviewChart: unknown,
  revenueChart: {
    title: string,
    value: string,
    percentage: number,
    period: string,
    data: IChartData[],
  },
}

interface ServiceDashboard extends Omit<ProponenteDashboard, 'contractsChart'> {
  contractsChart: ICompactChartData[],
}

export const dashboardService = {
  getProponenteDashboard: () => api.get<ProponenteDashboard>('/dashboard/proponente'),
  getServiceProviderDashboard: () => api.get<ServiceDashboard>('/dashboard/service-provider'),
};
